export default __webpack_public_path__ + "static/media/attach_mail.3eb7693f.svg";